<table class="value-table">
  <tr>
    <td></td>
    @for (weekDay of weekDays; track weekDay) {
      <td>{{ weekDay }}</td>
    }
  </tr>

  <tr>
    <td>8:00am</td>
    <td class="ok"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
  </tr>

  <tr>
    <td>9:30am</td>
    <td class="good"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
  </tr>

  <tr>
    <td>11:00am</td>
    <td class="good"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
  </tr>

  <tr>
    <td>12:30pm</td>
    <td class="good"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="best"></td>
  </tr>

  <tr>
    <td>2:00pm</td>
    <td class="good"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="good"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="good"></td>
  </tr>

  <tr>
    <td>3:30pm</td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="best"></td>
    <td class="best"></td>
    <td class="good"></td>
  </tr>

  <tr>
    <td>5:00pm</td>
    <td class="ok"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="ok"></td>
  </tr>

  <tr>
    <td>6:30pm</td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="good"></td>
    <td class="ok"></td>
    <td class="good"></td>
    <td class="good"></td>
    <td class="ok"></td>
  </tr>

  <tr>
    <td>8:00pm</td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
  </tr>

  <tr>
    <td>9:30pm</td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
    <td class="ok"></td>
  </tr>
</table>

<table class="value-legend">
  <tr>
    <td class="best">Best</td>
    <td class="good">Good</td>
    <td class="ok">Ok</td>
  </tr>
</table>
